import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss']
})
export class ExportDialog  {
  public type = 'file_download'
  
  constructor(
    public dialogRef: MatDialogRef<ExportDialog>,
    @Inject(MAT_DIALOG_DATA) public data) {
      if(data && data.type) {
        this.type = data.type;
      }
    }

  onNoClick(): void {
    this.dialogRef.close();
  }
 

}
